<template>
  <client-only>
    <div
      ref="tpl_container"
      component-name="player-vimeo"
      data-skin="skin-dark"
      class="bg-black"
    >
      <div :id="UUID" :data-vimeo-url="videoUrl" data-vimeo-defer></div>
    </div>
  </client-only>
</template>

<script setup>
// https://www.npmjs.com/package/@vimeo/player
import Player from "@vimeo/player";

const props = defineProps({
  videoUrl: {
    type: String,
    required: false,
  },
  autoplay: {
    type: Boolean,
    required: false,
    default: false,
  },
  pauseWhenOffscreen: {
    type: Boolean,
    required: false,
    default: true,
  },
  pauseWhenOffscreen: {
    type: Boolean,
    required: false,
    default: true,
  },
  onEnded: {
    type: Function,
    required: false,
    default: () => {},
  },
});

const UUID = ref(`uuid_${useId().replace("-", "")}`);

const tpl_container = templateRef("tpl_container");

let vimeoPlayer;
let stopObserver;
let wasPlaying = false;

onMounted(() => {
  const options = {
    color: "eeeeee",
    responsive: true,
    transparent: true,
    title: false,
    portrait: false,
    byline: false,
    share: false,
    playsinline: true,
    autoplay: props.autoplay,
    muted: props.autoplay,
    pip: false,
  };

  // Will create inside the div:
  // <iframe src="https://player.vimeo.com/video/59777392?h=ab882a04fd&loop=1" width="640" height="360" frameborder="0" allowfullscreen allow="autoplay; encrypted-media"></iframe>
  nextTick(() => {
    vimeoPlayer = new Player(UUID.value, options);
    if (props.pauseWhenOffscreen) {
      const { stop: stopObserver } = useIntersectionObserver(
        tpl_container,
        ([{ isIntersecting }], observerElement) => {
          vimeoPlayer
            .getPaused()
            .then(function (paused) {
              // `paused` indicates whether the player is paused
              if (!paused && !isIntersecting) {
                vimeoPlayer.pause();
                wasPlaying = true;
              } else if (paused && isIntersecting && wasPlaying) {
                vimeoPlayer.play();
                wasPlaying = false;
              }
            })
            .catch(function (error) {});
        }
      );

      document.addEventListener("visibilitychange", onVisibilityChange);
    }
    vimeoPlayer.on("ended", function () {
      props.onEnded();
    });
  });
});

const onVisibilityChange = () => {
  if (vimeoPlayer) {
    // document.visibilityState == "visible"
    //   ? vimeoPlayer.play()
    //   : vimeoPlayer.pause();
    vimeoPlayer
      .getPaused()
      .then(function (paused) {
        // `paused` indicates whether the player is paused
        if (!paused && document.visibilityState != "visible") {
          vimeoPlayer.pause();
          wasPlaying = true;
        } else if (
          paused &&
          document.visibilityState == "visible" &&
          wasPlaying
        ) {
          vimeoPlayer.play();
          wasPlaying = false;
        }
      })
      .catch(function (error) {});
  }
};

onBeforeUnmount(() => {
  document.removeEventListener("visibilitychange", onVisibilityChange);
  if (stopObserver) {
    stopObserver();
  }

  if (vimeoPlayer) {
    vimeoPlayer.destroy();
    vimeoPlayer.off("ended");
  }
});
</script>
